//src/components/footer.js

import React from "react"
import "../styles/scss/footer.scss" 
//import { Link } from "gatsby"
//import { rhythm } from "../utils/typography"

export default () => (
  <section className="footer-area">
   <div className="footer-text">
      <p> This Site is Powered by
        {` `}
      <a href="https://www.gatsbyjs.org">Gatsby</a> | Designed by TinjureWP </p> 
  </div>
</section>  
)
